import React from "react"
import { addTeamsFace,addUserFace } from "../Interfaces/Interfaces"
import * as yup from 'yup';


const addTeamsinintialValues:addTeamsFace={
    name:'',
    personIds:[],
    fromDate:null,
    managerId:'',
    tenantId:'',
    toDate:null
    
    }
      const addUserSchema = yup.object().shape({
        firstName:yup.string().required('نام اجباری است'),
        lastName:yup.string().required('نام خانوادگی اجباری است'),
        jobType:yup.string().required('عنوان شغلی اجباری است'),
        phoneNumber:yup.number().typeError('شماره تلفن میبایست عدد باشد').max(11111111111 ,'شماره تلفن نمیتواند بیشتر از 11 رقم باشد').min( 1111111111 ,'شماره تلفن نمیتواند کمتر از 11 رقم باشد'),
      });
      const addEmailSchema = yup.object().shape({
        email: yup.string().email('ایمیل معتبر نیست'),

      });

      const addTeamSchema = yup.object().shape({
        name:yup.string().required( 'نام اجباری است'),
        managerId:yup.string().required('انتخاب مدیر اجباری است'),
        // personIds: yup
        //   .array()
        //   .min(1, 'انتخاب حداقل یک عضو اجباری است') // حداقل یک عضو در آرایه
        //   .required('انتخاب اعضا اجباری است'),
      });

      const editTeamSchema = yup.object().shape({
        name:yup.string().required( 'نام اجباری است'),
        managerId:yup.string().required('انتخاب مدیر اجباری است'),
        // personIds: yup
        //             .array()
        //             .min(1, 'انتخاب حداقل یک عضو اجباری است') // حداقل یک عضو در آرایه
        //             .required('انتخاب اعضا اجباری است'),
                });
             
      const phoneNumberSchema = yup.object().shape({
        phoneNumber: yup.string().min(11).max(11)
      });

      const codeNumberSchema = yup.object().shape({
        code: yup.string().min(4)
      });

      const passValidationSchema = yup.object().shape({
        newPassword: yup.string()
          .required(''),
          confirmNewPassword: yup.string()
          .required('')
          .oneOf([yup.ref('newPassword')], ''),
          phoneNumber: yup.string().required('').length(11),
      });

      const passValidationSchema1 = yup.object().shape({
        // newPassword: yup.string()
        //   .required(''),
        //   confirmNewPassword: yup.string()
        //   .required('')
        //   .oneOf([yup.ref('newPassword')], ''),
        //   phoneNumber: yup.string().required('').length(11),
      });

      const registerByCodeValidationSchema = yup.object().shape({
        firstName: yup.string().required('نام الزامی است'),
        lastName: yup.string().required('نام خانوادگی الزامی است'),
        jobType: yup.string().required('عنوان شغلی الزامی است'),
        email: yup.string().email('ایمیل معتبر نیست').required('ایمیل الزامی است'),
        password: yup.string().nullable().min(6 , 'رمز عبور باید حداقل 6 کاراکتر باشد')
          .required('رمز عبور اجباری است'),
          confirmPassword:yup.string()
          .required('رمز عبور اجباری است').min(6 , 'رمز عبور باید حداقل 6 کاراکتر باشد'),
          phoneNumber: yup.string().required('').length(11),
        
      });

      const registerByCodeValidationSchema1 = yup.object().shape({
        jobType: yup.string().required('عنوان شغلی الزامی است'),
        email: yup.string().email('ایمیل معتبر نیست'),
      });

      const codeSchema = yup.object().shape({
        code: yup.string().required('کد الزامی است'),
      });

      const registerTenantValidationSchema = yup.object().shape({
        firstName: yup.string().required('نام الزامی است'),
        lastName: yup.string().required('نام خانوادگی الزامی است'),
        phoneNumber:yup.number().required('شماره تلفن الزامی است').typeError('شماره تلفن میبایست عدد باشد').max(11111111111 ,'شماره تلفن نمیتواند بیشتر از 11 رقم باشد').min( 1111111111 ,'شماره تلفن نمیتواند کمتر از 11 رقم باشد'),
        cEO: yup.string().required('نام شرکت الزامی است'),
        jobType: yup.string().required('عنوان شغلی الزامی است'),
        email: yup.string().email('ایمیل معتبر نیست'),
        userCountId: yup.string().required('نام شرکت الزامی است'),
        password: yup.string().nullable().min(6 , 'رمز عبور باید حداقل 6 کاراکتر باشد')
          .required('رمز عبور اجباری است'),
          confirmPassword:yup.string()
          .required('رمز عبور اجباری است').min(6 , 'رمز عبور باید حداقل 6 کاراکتر باشد'),
      });
      const registerTenantValidationSchema1 = yup.object().shape({
        cEO: yup.string().required('نام شرکت الزامی است'),
        jobType: yup.string().required('عنوان شغلی الزامی است'),
        userCountId: yup.string().required('نام شرکت الزامی است'),
      });

    export{
        addTeamsinintialValues,
        // addStaffInitialValues,
        addUserSchema,
        addTeamSchema,
        addEmailSchema,
        codeSchema,
        editTeamSchema,
        registerTenantValidationSchema,
        registerTenantValidationSchema1,
        phoneNumberSchema,
        codeNumberSchema,
        passValidationSchema,
        passValidationSchema1,
        registerByCodeValidationSchema,
        registerByCodeValidationSchema1
    }